<template>
  <div>
    <div class="all_body">
      <div class="header">
        <img :src="header_img" class="header-img" />
        <div class="header-text" :class="{'active':active === 0}" @click="tab(0,'/')">首页</div>
        <div class="header-text" :class="{'active':active === 1}" @click="tab(1,'/News/2')">新闻资讯</div>
        <!-- <div class="header-text" :class="{'active':active === 2}" @click="tab(2,'/MarketInfo')">行情报价</div> -->
        <div class="header-text" :class="{'active':active === 3}" @click="tab(3,'/Manager')">金鸡讲堂</div>
        <div class="header-text" :class="{'active':active === 6}" @click="tab(6,'/Systematic')">应用市场</div>
        <div class="header-text" :class="{'active':active === 4}" @click="tab(4,'/Us')">关于我们</div>
        <div class="header-text" :class="{'active':active === 5}" @click="tab(5)">客户端下载</div>
        <div class="login" v-if="this.$store.state.ticket == null">
          <button @click="login">注册/登录</button>
        </div>
        <div class="userInfo" v-if="this.$store.state.ticket">
          <div class="czLogin" @click="intoSys">
            <img :src="czxitong" alt class="czxitong" />
            <img :src="ks" alt class="ks" />
          </div>
          <div class="userInfo_line"></div>
          <div>
            <div class="user_avera" @click="goMyCenter">
              <img :src="this.$store.state.cover" alt />
            </div>
          </div>
          <div class="userInfo-name">
            <el-dropdown>
              <span class="el-dropdown-link">
                {{this.$store.state.real_name}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="goMyCenter">个人中心</span>
                </el-dropdown-item>
                <el-dropdown-item divided>
                  <span @click="logout">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="right_ling" @click="drawer = true">
            <div v-if="noreadCount != 0">
              <el-badge :value="noreadCount" class="item">
                <img :src="ling" />
              </el-badge>
            </div>
            <div v-else>
              <img :src="ling" />
            </div>
          </div> -->
          <div class="right_ling">
            <img :src="ling" />
          </div>
        </div>
      </div>

      <div v-if="isDownload">
        <div class="download_box"></div>
        <div class="download_box_1"></div>
        <div class="download" :class="{'create_down':textShow}">
          <div class="djgj_content">
            <img :src="djgj" alt />
          </div>
          <div class="download_right">
            <div class="download_right_font">扫码下载官方APP</div>
            <div class="download_right_ios">
              <img :src="ios" alt />
            </div>
            <div class="download_right_android">
              <img :src="android" alt />
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-drawer :visible.sync="drawer" :with-header="false">
      <div class="message">消息（{{total}}）</div>
      <div class="message_line"></div>
      <div class="message_c">
        <div v-for="(item,index) in message_list" :key="index" class="message_kuang">
          <div class="message_content" @click="readMess(item.id)">
            <div class="message_dian_1">
              <div class="message_dian" v-if="item.is_show == 0"></div>
            </div>
            <div class="message_title">{{item.title}}</div>
          </div>
          <div class="message_time">{{item.created}}</div>
          <div class="message_content_line"></div>
        </div>
      </div>

      <!-- <div cla;ss="meaasge_footer">清空全部</div> -->
    </el-drawer>

    <router-view />

    <div class="footer">
      <div class="footer_1">
        © 2017 嘉农在线 版权所有 ICP证：<a href="https://beian.miit.gov.cn/">京ICP备15062174号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
import { webSocketCallBack, getmessagelist, readMessage } from "../api/api";
export default {
  name: "Layout",
  data() {
    return {
      header_img: "./static/img/title@2.png",
      shuju: "./static/img/shuju.png",
      czxitong: "./static/img/czxitong.png",
      ks: "./static/img/ks.png",
      djgj: "./static/img/djgj.png",
      ios: "./static/img/ios.png",
      android: "./static/img/android.png",
      ling: "./static/img/ling.png",
      active: "",
      loginIn: false,
      isDownload: false,
      real_name: "",
      textShow: false,
      drawer: false,
      path: "ws://breed.danjiguanjia.com:8282/",//正式
      // path: "ws://breed.test.jianong.com:8282/",//测试
      noreadCount: 0,
      total: 0,
      message_list: []
    };
  },

  beforeCreate() {
    console.log("beforeCreate");
  },
  created() {
    console.log("created");
  },
  mounted() {
    this.active = this.$store.state.nav;
    this.$store.state.ticket = localStorage.getItem("ticket");
    this.$store.state.real_name = localStorage.getItem("real_name");
    this.$store.state.cover = localStorage.getItem("cover");
    this.init();
    this.getmessagelists();
  },
  updated() {
    this.active = this.$store.state.nav;
    this.$store.state.ticket = localStorage.getItem("ticket");
    this.$store.state.real_name = localStorage.getItem("real_name");
    this.$store.state.cover = localStorage.getItem("cover");
  },
  methods: {
    readMess(id) {
      readMessage({
        ticket: localStorage.getItem("ticket"),
        id: id
      }).then(res => {
        if (res.code == "200") {
          this.getmessagelists();
        }
      });
    },
    getmessagelists() {
      getmessagelist({
        ticket: localStorage.getItem("ticket")
      }).then(res => {
        this.message_list = res.data.data;
        this.noreadCount = res.data.noreadCount;
        this.total = res.data.total;
      });
    },
    init() {
      if (localStorage.getItem("ticket")) {
        if (typeof WebSocket === "undefined") {
          this.$message.error("您的浏览器不支持socket");
          return false;
        } else {
          // 实例化socket
          this.socket = new WebSocket(this.path);
          // 监听socket连接
          this.socket.onopen = this.open;
          // 监听socket错误信息
          this.socket.onerror = this.error;
          // 监听socket消息
          this.socket.onmessage = this.getMessage;
        }
      }
    },
    open: function() {
      console.log("socket连接成功");
    },
    error: function() {
      console.log("连接错误");
    },
    getMessage: function(msg) {
      console.log("socket接收消息");
      this.getmessagelists();
      var received_msg = msg.data;
      if (this.isJsonString(received_msg)) {
        var jmsg = JSON.parse(received_msg);
      } else {
        var jmsg = received_msg;
        this.$message.success(jmsg);
        return false;
      }
      if (jmsg.client_id.length == 20) {
        webSocketCallBack({
          client_id: jmsg.client_id,
          ticket: localStorage.getItem("ticket")
        }).then(response => {
          if (parseInt(response.code) === 200) {
          } else {
          }
        });
      }
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {}
      return false;
    },
    send: function() {
      console.log("socket发送消息");
      this.socket.send(params);
    },
    close: function() {
      console.log("socket已经关闭");
    },
    tab(e, url) {
      if (e == 5) {
        this.isDownload = !this.isDownload;
        this.textShow = true;
      } else {
        this.isDownload = false;
      }
      this.$store.commit("settab", e);
      this.$router.push(url);
      this.active = this.$store.state.nav;
    },
    goMyCenter() {
      this.$router.push("/p/System");
    },
    login() {
      this.$router.push("/Login");
      localStorage.setItem("local", "/p/System");
    },
    logout() {
      localStorage.clear();
      this.$message({
        message: "退出成功",
        type: "success"
      });
      setTimeout(() => {
        this.$router.push("/Login");
      }, 1000);
    },
    intoSys() {
      this.$router.push("/p/System");
    }
  }
};
</script>

<style>

.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
  position: relative;
}

.header {
  position: relative;
  display: flex;
  height: 80px;
  margin-top: 30px;
}
.header-img {
  width: 153px;
  height: 77px;
  margin-right: 20px;
}
.header-text {
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  font-weight: 200;
  color: rgba(0, 0, 0, 1);
  padding-left: 40px;
  margin-top: 20px;
  cursor: pointer;
  white-space: nowrap;
}

.login button {
  position: absolute;
  right: 0;
  top: 40px;
  height: 40px;
  width: 115px;
  border-radius: 6px;
  background: rgba(44, 152, 80, 1);
  font-size: 16px;
  color: #ffffff;
  outline: none;
  cursor: pointer;
}

.active {
  color: rgba(44, 152, 80, 1);
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  line-height: 100px;
  width: 100%;
  background: #9cc637;
  color: #000000;
}
.footer_1 {
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  text-align: center;
}

a{
  color: #000000;
}

a:link.a:visited,a:hover,a:active{
  color: #000000;
}

.userInfo {
  display: flex;
  width: 400px;
  margin-left: 150px;
  height: 80px;
  align-items: center;
  margin-top: 20px;
  float: right;
}
.czLogin {
  position: relative;
  width: 103px;
  height: 44px;
  cursor: pointer;
}
.czxitong {
  width: 102px;
  height: 44px;
}
.ks {
  width: 21px;
  height: 21px;
  position: absolute;
  left: 0;
  margin-top: 10px;
  margin-left: 8px;
  z-index: 99;
}
.userInfo_line {
  margin-left: 19px;
  height: 50px;
  width: 1px;
  background: #c0c0c0;
}
.user_avera {
  width: 50px;
  height: 50px;
  margin-left: 16px;
  cursor: pointer;
}
.user_avera img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.userInfo-name {
  margin-left: 5px;
  font-size: 18px;
  color: #060001;
  cursor: pointer;
}
.download {
  position: absolute;
  z-index: 98;
  display: flex;
  width: 436px;
  height: 224px;
  margin-top: 30px;
  background: #ffffff;
  margin-left: 730px;
  border: 1px solid #c8c5c6;
  transition: all 0.3s;
  opacity: 0;
  transform: scale(0) translateY(200%);
}
.create_down {
  opacity: 1;
  transform: scale(1) translateY(0);
}
.download_box {
  position: absolute;
  right: -400px;
  left: 0;
  top: 100px;
  margin: 0 auto;
  width: 23px;
  height: 23px;
  background: #ffffff;
  transform: rotate(45deg);
  border: 1px solid #c8c5c6;
  z-index: -999;
}
.download_box_1 {
  position: absolute;
  right: -400px;
  left: 0;
  top: 102px;
  margin: 0 auto;
  width: 20px;
  height: 20px;
  background: #ffffff;
  transform: rotate(45deg);
  z-index: 99;
}
.djgj_content {
  margin-left: 28px;
  margin-top: 32px;
  width: 165px;
  height: 165px;
}
.djgj_content img {
  width: 100%;
  height: 100%;
}
.download_right {
  margin-left: 32px;
}
.download_right_font {
  margin-top: 29px;
  font-size: 22px;
}
.download_right_ios {
  width: 186px;
  height: 54px;
  margin-top: 13px;
}
.download_right_ios img {
  width: 100%;
  height: 100%;
}
.download_right_android {
  width: 186px;
  height: 54px;
  margin-top: 13px;
}
.download_right_android img {
  width: 100%;
  height: 100%;
}
.right_ling {
  margin-left: 10px;
}
.el-drawer {
  width: 100px;
}
.message {
  margin-left: 50px;
  margin-top: 30px;
  font-size: 22px;
}
.message_line {
  width: 100%;
  height: 1px;
  background: #aaaaaa;
  margin-top: 20px;
}
.message_content {
  margin: 20px 20px 10px 20px;
  font-size: 20px;
  color: #878787;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.message_time {
  font-size: 16px;
  color: #878787;
  margin-left: 10%;
}
.message_content_line {
  height: 2px;
  background: #cecece;
  margin: 20px 20px 0 20px;
}
.meaasge_footer {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 22px;
  text-align: center;
  border-top: 1px solid #aaaaaa;
  color: #6b6b6b;
  position: absolute;
  bottom: 0;
  cursor: pointer;
}
.message_c {
  overflow: hidden;
  height: 85%;
  overflow-y: auto;
}
.message_dian_1 {
  width: 10%;
}
.message_dian {
  width: 5px;
  height: 5px;
  background: red;
  border-radius: 50%;
}
.message_title {
  margin-left: -5px;
}
.message_kuang{
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue